<!-- separation.component.html -->
<div class="card">
    <div class="card-header">
        Separation Policy
    </div>
    <div class="card-body">
        <div class="d-flex align-items-center justify-content-start">
            <label for="lastWorkingDay" class="me-2 mb-0 text-label-dark">
                Allow employee to suggest last working day:
            </label>

            <input type="checkbox" class="form-check-input" id="lastWorkingDay">
        </div>

        <div class="d-flex align-items-center justify-content-start mt-2">
            <label for="lastWorkingDay" class="me-2 mb-0 text-label-dark">
                Allow backdate separation <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                    [ngbTooltip]="tooltip.LeavePolicy.Minimumdaystobepresentforleaveeligibility"></i> :
            </label>

            <input type="checkbox" class="form-check-input" id="lastWorkingDay" [(ngModel)]="allowBackdateSeparation">

            <!-- <label for="lastWorkingDay" class="me-2 mb-0">
                Backgate separation Days :
            </label> -->

            <div class="col-md-3 mt-4 ms-4">
                <div class="input-group mb-3">
                    <input type="text" maxlength="3" pattern="^[0-9.]*$" (keypress)="common.NumberOnly($event)"
                        class="form-control form-control2 text-label-light" placeholder="Ex. 01"
                        id="MinimumDaysForLeaveEligibility" name="MinimumDaysForLeaveEligibility" required>
                    <span class="input-group-text form-label" id="basic-MinimumDaysForLeaveEligibility">Separation
                        Days</span>
                    <div class="invalid-feedback">
                        Please enter maximum days 365!
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-auto align-self-center mt-1">
                <label for="LeaveType" class="form-label text-label-dark">Leave Type :</label>
            </div>
            <div class="col-md-5 mt-2">
                <div class="btn-group btn-group-toggle">
                    <label class="form-check-label link-dark px-1 form-label" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='Month' name="policybased"
                            [(ngModel)]="policybasedon" [ngModelOptions]="{standalone: true}">
                        Months
                    </label>
                    <label class="form-check-label link-dark px-1 form-label" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='Day' name="policybased"
                            [(ngModel)]="policybasedon" [ngModelOptions]="{standalone: true}">
                        Days
                    </label>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-auto mt-2">
                <label for="lastWorkingDay" class="me-2 mb-0 text-label-dark">
                    Probation:
                </label>
            </div>
            <div class="col-md-2">
                <input type="text" class="form-control" placeholder="Ex. 01">
            </div>
        </div>

        <div class="row">
            <div class="col-auto mt-2">
                <label for="lastWorkingDay" class="me-2 mb-0 text-label-dark">
                    Confirmation:
                </label>
            </div>
            <div class="col-md-2">
                <input type="text" class="form-control" placeholder="Ex. 01">
            </div>
        </div>

    </div>

    <div class="card m-2 mx-3">
    <div class="card-header">
        <div class="row">
            <div class="col">User Applicability</div>
            <div class="col-md-3">
                <div class="input-group">
                    <div class="input-group-text"><i class="bi bi-search"></i></div>
                    <input type="text" class="form-control" placeholder="Search Here.."
                        (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                    (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Filter':'Loading...'}}</button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="row mt-2">
            <div class="col-md-3">
                <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                    @for (Applicability of Applicabilitys; track Applicability.WebESSUserApplicabilityMasterID; let i =
                    $index) {
                    <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                        <input class="form-check-input" type="radio" [value]=Applicability.WebESSUserApplicabilityMasterID
                            name='WebESSUserApplicabilityMasterID'
                            [(ngModel)]="ShiftRuleDetail.WebESSUserApplicabilityMasterID"
                            [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                            [disabled]="Applicability.WebESSApplicabilityMasterID == 0">
                        {{Applicability.ApplicabilityName}}
                        <i *ngIf="Applicability.WebESSUserApplicabilityMasterID == 3 || Applicability.WebESSUserApplicabilityMasterID == 7"
                            class="bi bi-funnel"></i>
                    </label>
                    }
                </div>
            </div>
            <div class="col-md-9">
                <div class="row">
                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                        <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                            (change)="ApplicabilityCheckAll($event)">
                        <label for="SelectAll">
                            Select All
                        </label>
                    </div>
                </div>
                <div class="row">
                    <label
                        *ngIf="ApplicabilityDatas.length == 0 && ShiftRuleDetail.WebESSUserApplicabilityMasterID > 0">Please
                        select filter</label>
                    @for (ApplicabilityData of OrderByApplicability(); track
                    ApplicabilityData.ApplicabilityDataID;
                    let i = $index) {
                    <div class="col-md-4">
                        <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                            <input class="form-check-input" type="checkbox"
                                id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                [(ngModel)]="ApplicabilityData.IsCheck">
                            <label class="form-check-label applicability-font"
                                for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                {{ApplicabilityData.ApplicabilityData}}
                            </label>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

</div>